/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './cervix.reducer';

export const CervixDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const cervixEntity = useAppSelector(state => state.cervix.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="cervixDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.cervix.detail.title">Cervix</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.cervix.id">Id</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.id}</dd>
          <dt>
            <span id="opening">
              <Translate contentKey="tinyMedicRestApp.cervix.opening">Opening</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.opening}</dd>
          <dt>
            <span id="firmness">
              <Translate contentKey="tinyMedicRestApp.cervix.firmness">Firmness</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.firmness}</dd>
          <dt>
            <span id="position">
              <Translate contentKey="tinyMedicRestApp.cervix.position">Position</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.position}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.cervix.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.cervix.active">Active</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.cervix.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.cervix.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.cervix.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.cervix.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.cervix.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{cervixEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.cervix.cycleDay">Cycle Day</Translate>
          </dt>
          <dd>{cervixEntity.cycleDay ? cervixEntity.cycleDay.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/cervix" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cervix/${cervixEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CervixDetail;
